import { LogoutOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, FloatButton, Input, List, Modal, Tag, Typography } from "antd";
import useCambiarFilial from "components/CambiarFilial/useCambiarFilial";
import { ROL_COLORS } from "constants/accesos";
import { IS_FILIAL_SELECTED } from "constants/auth";
import useLogout from "hooks/useLogout";
import { useState } from "react";

const ElegirFilialUsuario = ({ filiales, usuarioId, onClose }) => {
  const { handleCambiarFilial, loading } = useCambiarFilial('CAMBIAR_FILIAL');
  const { logout } = useLogout();
  const [searchValue, setSearchValue] = useState("");
  const isFilialSelected = localStorage.getItem(IS_FILIAL_SELECTED);
  const many = filiales.length > 10;
  const filteredFiliales = filiales.filter((filial) =>
    filial.nombre.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <Modal
      open={true}
      title="Seleccione una Filial"
      centered
      okButtonProps={{ style: { display: "none" } }}
      confirmLoading={loading}
      closable={false}
      footer={
        <>
          {isFilialSelected && (
            <Button onClick={onClose}>
              Cancelar
            </Button>
          )}
          <Button type="primary" danger icon={<LogoutOutlined />} onClick={logout}>
            Cerrar sesión
          </Button>
        </>
      }
      width={500}
    >
      {many && (
        <Input
          placeholder="Buscar filial..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          prefix={<SearchOutlined style={{ color: "#999" }} />}
          style={{
            marginBottom: "16px",
          }}
        />
      )}

      <div
        id="scrollable-container"
        style={{
          maxHeight: "420px",
          overflowY: "auto",
          paddingRight: "8px",
        }}
      >
        <List
          dataSource={filteredFiliales}
          renderItem={(filial) => (
            <List.Item
              key={filial.id}
              onClick={() => handleCambiarFilial(usuarioId, filial.id)}
              style={{
                cursor: "pointer",
                padding: "12px",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <Typography.Text style={{ whiteSpace: 'nowrap' }}>
                {filial.codigo} - {filial.nombre}
              </Typography.Text>
              <div style={{ textAlign: 'end' }}>
                {filial?.roles?.map((rol, i) => (
                  <Tag
                    key={i}
                    color={ROL_COLORS[rol.id]}
                    style={{
                      fontSize: 10,
                      textWrap: 'wrap',
                      margin: 0,
                      marginLeft: '8px',
                    }}
                  >
                    {rol.rol}
                  </Tag>
                ))}
              </div>
            </List.Item>
          )}
        />

        {filteredFiliales.length === 0 && (
          <Typography.Text
            type="secondary"
            style={{
              display: "block",
              textAlign: "center",
              marginTop: "16px",
            }}
          >
            No se encontraron filiales.
          </Typography.Text>
        )}
      </div>
      <FloatButton.BackTop
        style={{ insetInlineEnd: 950 }}
        target={() => document.getElementById("scrollable-container")}
      />
    </Modal>
  );
};

export default ElegirFilialUsuario;
